import { useLocation } from 'react-router-dom';
import Navbar from '../../../components/Navbar'
import Sanciones from '../../administrador/components/SancionesForm'

const InformesInicio = () => {
    const location = useLocation();
    const informeToEdit = location.state?.informeToEdit || null;
    
    return(
        <div>
            <Navbar></Navbar>
            <Sanciones informeToEdit={informeToEdit}></Sanciones>
        </div>
    );
}

export default InformesInicio;